import { gql } from '@apollo/client'

import { TotalOfItems } from './types'

export type NumberStakers = TotalOfItems

export const QUERY_GET_NUMBER_STAKERS = gql`
  query NumberStakers($stakeAddr: String!) {
    total: balance_aggregate(where: { token: { collection_id: { _eq: $stakeAddr } } }) {
      agg: aggregate {
        count
      }
    }
  }
`
